import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectRecentChanges } from 'store/recentChanges';
import RecentChangesPill from './RecentChangesPill';
import RecentChangesDrawer from './RecentChangesDrawer';

// Self-contained entry: pill (shown only when >=1 change) + the full-screen drawer.
const RecentChanges = ({ sheetId }) => {
  const items = useSelector(selectRecentChanges(sheetId));
  const [open, setOpen] = useState(false);

  if (!items.length) return null;

  return (
    <>
      <RecentChangesPill latestNotifiedAt={items[0].notifiedAt} onClick={() => setOpen(true)} />
      <RecentChangesDrawer open={open} onClose={() => setOpen(false)} items={items} />
    </>
  );
};

export default RecentChanges;
